export const mapWithConcurrency = async <TIn, TOut>(
  items: readonly TIn[],
  limit: number,
  mapper: (item: TIn, index: number) => Promise<TOut>,
): Promise<TOut[]> => {
  const results = new Array<TOut>(items.length);
  let next = 0;

  const worker = async (): Promise<void> => {
    while (next < items.length) {
      const index = next;
      next += 1;
      results[index] = await mapper(items[index], index);
    }
  };

  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, worker),
  );

  return results;
};
